import { useQuery } from '@tanstack/react-query';
import { fetchBetRecommendations } from '../../api/sportsbook-api';
import { RefetchInterval, StaleTime } from '../../sportsbook-constants';
import { SPORTSBOOK_QUERY_KEY } from '../queries-constants';
import { RecommendedBetDto } from '../../api/sbapi/sbapi-api-model';

type Params = {
	key: string;
};

type Options<TData> = {
	select?: (data: RecommendedBetDto[]) => TData;
	staleTime?: StaleTime;
	refetchInterval?: RefetchInterval;
	isEnabled?: boolean;
	refetchOnWindowFocus?: boolean;
};

/**
 * Hook for querying bet recommendations
 */
const useQueryBetRecommendations = <TData = RecommendedBetDto[]>(params: Params, options?: Options<TData>) =>
	useQuery({
		queryKey: [SPORTSBOOK_QUERY_KEY, 'bet-recommendations', params.key],
		queryFn: () => fetchBetRecommendations(params.key),
		enabled: options?.isEnabled,
		staleTime: options?.staleTime ?? StaleTime.ZERO,
		refetchInterval: options?.refetchInterval,
		select: options?.select,
		refetchOnWindowFocus: options?.refetchOnWindowFocus,
		meta: {
			errorMessage: `Failed to fetch bet recommendations`
		}
	});

export default useQueryBetRecommendations;
